'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WebItemInfo = require('./components/WebItemInfo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebItemInfo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/web-item-info/index.js
// module id = 1059
// module chunks = 0